import type { ProcessStepRecordingDisplay } from '@bliks-io/contracts';

export function meanSurveyMetric<T>(
  surveys: T[] | undefined,
  select: (survey: T) => number | undefined
): number | null {
  const values = (surveys ?? [])
    .map(select)
    .filter((value): value is number => typeof value === 'number');
  return values.length > 0 ? values.reduce((sum, value) => sum + value, 0) / values.length : null;
}

/**
 * Frequency is categorical, so (unlike rating and duration) it cannot be
 * averaged — one survey's value represents the step. It has to be the first row
 * that ACTUALLY carries one: a dismissed row (ADR 0022) is terminal with no
 * answers at all, so a bare `surveys[0]` can now report a step as having no
 * recorded frequency.
 */
export function firstSurveyFrequency(
  surveys: ProcessStepRecordingDisplay['surveys']
): NonNullable<ProcessStepRecordingDisplay['surveys']>[number]['frequency'] {
  return (surveys ?? []).find((survey) => survey.frequency?.value)?.frequency;
}
